'use client'
import React from 'react'

export default function Error(props) {
  return (
    <div className="error">
      <div className="error-icon" />
      <p>{props.data.message}</p>
    </div>
  )
}
